import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { version } from '../../package.json';

const Footer = () => {
  return (
    <footer className='footer bg-light mt-auto'>
      <Container fluid>
        <Row>
          <Col className='text-right'>UI: {version} API: 1.0.0</Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
